import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-gray-700 text-sm" }
const _hoisted_4 = {
  key: 0,
  class: "absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto"
}
const _hoisted_5 = {
  key: 0,
  class: "sticky top-0 bg-white px-3 py-2 border-b border-gray-100"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-gray-600 group-hover:text-purple-500 text-sm" }
const _hoisted_9 = {
  key: 1,
  class: "px-3 py-2 text-sm text-gray-400 text-center"
}

import { ref, computed, watch, nextTick, onMounted, onBeforeUnmount } from "vue"
import { ChevronDown } from "lucide-vue-next"

export interface Option {
    label: string
    value: string
    icon?: string
    searchLabel?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomSelect',
  props: {
    options: {},
    modelValue: {},
    searchable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const open = ref(false)
const wrapper = ref<HTMLElement | null>(null)
const searchInput = ref<HTMLInputElement | null>(null)
const searchQuery = ref("")

const filteredOptions = computed(() => {
    if (!props.searchable || !searchQuery.value) return props.options
    const q = searchQuery.value.toLowerCase()
    return props.options.filter((opt) => {
        const searchTarget = opt.searchLabel || opt.label
        return searchTarget.toLowerCase().includes(q)
    })
})

const toggle = () => {
    open.value = !open.value
}

watch(open, (isOpen) => {
    if (isOpen && props.searchable) {
        searchQuery.value = ""
        nextTick(() => searchInput.value?.focus())
    }
})

const select = (opt: Option) => {
    emit("update:modelValue", opt)
    open.value = false
}

const onClickOutside = (e: MouseEvent) => {
    if (wrapper.value && !wrapper.value.contains(e.target as Node)) {
        open.value = false
    }
}

onMounted(() => {
    document.addEventListener("click", onClickOutside)
})

onBeforeUnmount(() => {
    document.removeEventListener("click", onClickOutside)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapper",
    ref: wrapper,
    class: "relative w-36"
  }, [
    _createElementVNode("div", {
      onClick: toggle,
      class: "h-full border border-gray-300 rounded-lg px-3 flex items-center justify-between cursor-pointer bg-white/80 hover:bg-white transition"
    }, [
      _createElementVNode("div", _hoisted_1, [
        (__props.modelValue?.icon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.modelValue.icon,
              class: "w-5 h-5 rounded-sm object-cover"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.modelValue?.label || "Select"), 1)
      ]),
      _createVNode(_unref(ChevronDown), {
        class: _normalizeClass(["w-4 h-4 text-gray-500 transition-transform duration-200", open.value ? 'rotate-180' : ''])
      }, null, 8, ["class"])
    ]),
    _createVNode(_Transition, { name: "fade-scale" }, {
      default: _withCtx(() => [
        (open.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (__props.searchable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                      ref_key: "searchInput",
                      ref: searchInput,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                      type: "text",
                      placeholder: "Search...",
                      class: "w-full text-sm text-gray-700 outline-none placeholder-gray-400",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                    }, null, 512), [
                      [_vModelText, searchQuery.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (opt, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "group flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-purple-50",
                  onClick: ($event: any) => (select(opt))
                }, [
                  (opt.icon)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: opt.icon,
                        class: "w-5 h-5 rounded-sm object-cover"
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(opt.label), 1)
                ], 8, _hoisted_6))
              }), 128)),
              (__props.searchable && filteredOptions.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " No results "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})